const invoicesFR = {
    "view": {
        "table": {
            "title": "Votre liste de factures",
            "column": {
                "issueDate": "Date d'émission",
                "invoiceNumber": "Numéro de facture",
                "status": "Statut",
                "totalAmount": "Montant total",
                "downloadPDF": "Télécharger le PDF",
                "whtStatement": "Déclaration WHT"
            },
            "label": {
                "notApplicable": "Non applicable"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "button": {
                "download": "Télécharger",
                "exportCSV": "Exporter CSV"
            }
        },
        "message": {
            "cantAddInvoices": "Malheureusement, vous ne pouvez pas actuellement ajouter de factures. Soit vos données de compte fiscal ou de paiement ne sont pas entièrement complétées. Pour débloquer cette fonctionnalité, veuillez contacter notre équipe de support.",
            "invoicingNotAvailable": "Générez des factures du 3 au 22 de chaque mois. Notez que la génération de factures n'est pas possible du 23 au 2 du mois suivant, car les paiements automatisés sont traités pendant cette période. Merci pour votre compréhension.",
            "generatingInvoices": "Vous ne pouvez pas ajouter de factures pour le moment car vous avez des factures qui sont actuellement en cours de génération. Veuillez revenir plus tard.",
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour bénéficier de cette fonctionnalité.",
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour bénéficier de cette fonctionnalité."
        }
    },
    "add": {
        "title": "Ajouter une facture",
        "form": {
            "table": {
                "statements": {
                    "title": "Déclarations disponibles pour la facturation"
                }
            },
            "button": {
                "generateInvoice": "Générer la facture"
            }
        },
        "message": {
            "success": "La facture a été ajoutée !",
            "error": "Quelque chose a mal tourné ! Veuillez rafraîchir la page et réessayer !",
            "noStatementAvailable": "Aucune déclaration disponible pour la facturation.",
            "invoicingLimitNotReached": "Vous ne pouvez pas actuellement ajouter de factures car le montant total à payer est inférieur ou égal à <strong>0€</strong>."
        },
        "modal": {
            "header": "Ajouter une facture",
            "body": "Êtes-vous sûr de vouloir créer une facture pour les déclarations actuellement OUVERTES ?"
        }
    }
};

export default invoicesFR;